import React, { useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { useForm, useFormState } from 'react-final-form';
import tablePlacement from '../../../assets/tablePlacement.png';
import InputField from '../../../Components/InputField';

export default function TablePlacementPrompt() {
  const { values } = useFormState();
  const form = useForm();

  useEffect(() => {
    for (const table of values.eventTables) {
      if (table.placementWish) continue;
      table.placementWish = 'noPreference';
    }
    form.change('placementWish', values.eventTables);
  }, []);

  return (
    <Grid container spacing={2} sx={{ marginTop: '20px' }}>
      {values.eventTables.map((table, index) => (
        <>
          {values.eventTables?.length > 1 ? (
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginTop: '20px', marginBottom: '10px' }}>
                Tisch
                {' '}
                {index + 1}
              </Typography>
            </Grid>
          ) : null}
          <Grid item xs={12} md={6} sx={{ textAlign: 'center', padding: '50px !important' }}>
            <img src={tablePlacement} alt="" style={{ width: '100%' }} />
          </Grid>
          <Grid item xs={12} md={6} sx={{ alignItems: 'center', display: 'flex', paddingTop: '0px !important' }}>
            <InputField
              type="select"
              name={`eventTables.${index}.placementWish`}
              label={`${values.eventTables?.length > 1 ? `Tisch ${index + 1} ` : ''}Tischplatzierung`}
              gridSize={{ xs: 12 }}
              options={[
                { name: 'keine Präferenz', value: 'noPreference' },
                { name: 'Zentrum', value: 'center' },
                { name: 'Mittlerer Ring', value: 'middleRing' },
                { name: 'Äußerer Ring', value: 'outerRing' },
              ]}
            />
          </Grid>

        </>
      ))}
    </Grid>
  );
}
